/* ============================================================================
   ag-cart-drawer.js
   Loaded globally via ag-quick-add. Handles:
   1. Gender-aware upsell fetch (single collection, Shopify tag filtering)
   2. Size strip toggle for card taps inside cart drawer
   ============================================================================ */

(function() {
  'use strict';

  var sidebar = document.getElementById('sidebar-cart');
  if (!sidebar) return;

  /* === UPSELL FETCH (debounced to survive Prestige DOM replacement) === */
  var upsellTimer = null;

  function loadUpsell() {
    var upsellEl = sidebar.querySelector('[data-ag-cart-upsell]');
    if (!upsellEl) return;
    /* Check element is actually connected to the live DOM */
    if (!upsellEl.isConnected) return;

    var gridEl = upsellEl.querySelector('[data-ag-upsell-grid]');
    var url = upsellEl.dataset.agUpsellUrl;
    if (!gridEl || !url || gridEl.children.length > 0) return;

    fetch(url, { credentials: 'same-origin' })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        /* Re-query to make sure the grid still exists after async fetch */
        var freshGrid = sidebar.querySelector('[data-ag-upsell-grid]');
        if (!freshGrid || !freshGrid.isConnected) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('.ag-card');

        if (cards.length === 0) {
          var freshUpsell = freshGrid.closest('[data-ag-cart-upsell]');
          if (freshUpsell) freshUpsell.style.display = 'none';
          return;
        }

        var frag = document.createDocumentFragment();
        cards.forEach(function(card) { frag.appendChild(card); });
        freshGrid.appendChild(frag);

        freshGrid.querySelectorAll('.ag-card__size:not([data-original-text])').forEach(function(btn) {
          btn.dataset.originalText = btn.textContent;
        });
      })
      .catch(function() {
        var el = sidebar.querySelector('[data-ag-cart-upsell]');
        if (el) el.style.display = 'none';
      });
  }

  loadUpsell();

  var observer = new MutationObserver(function() {
    clearTimeout(upsellTimer);
    upsellTimer = setTimeout(loadUpsell, 150);
  });
  observer.observe(sidebar, { childList: true, subtree: true });

  /* === SIZE STRIP TOGGLE — tap anywhere on upsell card === */
  sidebar.addEventListener('click', function(e) {
    var card = e.target.closest('.ag-cart-upsell .ag-card');
    if (!card) return;
    if (e.target.closest('.ag-card__size')) return;
    if (e.target.closest('a')) return;

    e.preventDefault();
    e.stopPropagation();

    sidebar.querySelectorAll('.ag-cart-upsell .ag-card.is-showing-sizes').forEach(function(c) {
      if (c !== card) c.classList.remove('is-showing-sizes');
    });

    card.classList.toggle('is-showing-sizes');
  }, true);

  /* === SHIPPING INFO ACCORDION TOGGLE === */
  sidebar.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-ag-shipping-info-toggle]');
    if (!toggle) return;

    e.preventDefault();
    toggle.classList.toggle('is-open');

    var content = toggle.nextElementSibling;
    if (content && content.hasAttribute('data-ag-shipping-info-content')) {
      content.classList.toggle('is-open');
    }
  });

})();
